<template>
	<strong v-if="page.selected">{{ page.dispPage }}</strong>
	<a v-else @click="() => {if(!disabled) movePage(page.movePage);}" :class="disabled ? 'disabled' : ''">{{ page.dispPage }}</a>
</template>


<script>
export default {
	name: 'PageBtn',
	emits: ['movePage'],
	props: {
		page: {
			type: Object
		},
		disabled: {
			type: Boolean
		},
	},
	methods: {
		movePage(page) {
			this.$emit('movePage', page);
		},
	}
}
</script>